/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Lead/view.blocks to change it.
import Details from './Details/index'
import DetailsAction from './DetailsAction/index'
import Info from './Info/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Lead({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/SimilarPatients/Content/Content/SimilarPerson/Lead"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Lead.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Info
  viewPath={`${viewPath}/Info`}
/>
<DetailsAction
  viewPath={`${viewPath}/DetailsAction`}
/>
</div>
<Details
  viewPath={`${viewPath}/Details`}
/>
{children}
</React.Fragment>)
}